/**
 * DevToolsSection — Show QR Test Panel toggle (extracted from the old god
 * component's `renderDevTools`), converted to the Console dirty model.
 */
import { useState } from 'react';
import { Beaker } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import { useProductionSettings } from '../hooks/useProductionSettings';
import { SettingsSection } from '../components/console/SettingsSection';
import { SettingRow } from '../components/console/SettingRow';
import { useDirtyRegistration } from '../components/console/SettingsDirtyContext';

export function DevToolsSection() {
  const { settings, updateSetting } = useProductionSettings();
  const [pending, setPending] = useState(settings.showDevTools);

  const isDirty = pending !== settings.showDevTools;

  useDirtyRegistration(
    'dev-tools',
    isDirty
      ? {
          label: 'Developer tools',
          save: () => {
            updateSetting('showDevTools', pending);
            return Promise.resolve();
          },
          discard: () => setPending(settings.showDevTools),
        }
      : null,
  );

  return (
    <SettingsSection id="dev-tools" title="Developer tools" scope="browser" icon={Beaker}>
      <SettingRow
        htmlFor="show-dev-tools"
        label="Show QR Test Panel"
        description="Display the QR code test panel on station pages for testing without physical scanners"
      >
        <Switch
          id="show-dev-tools"
          checked={pending}
          onCheckedChange={setPending}
          aria-describedby="show-dev-tools-status"
        />
        <span id="show-dev-tools-status" className="sr-only">
          {pending ? 'Currently enabled' : 'Currently disabled'}
        </span>
      </SettingRow>
    </SettingsSection>
  );
}
